import { useSelector } from 'react-redux';

export const useUserLoginStatus = () => {
  const user = useSelector((state) => state.user);
  return user?._id;
};

export const getIds = () => {
  const userData = localStorage.getItem('user');
  const user = userData && userData !== 'undefined' ? JSON.parse(userData) : null;
  const userId = user?._id;
  const guestId = localStorage.getItem('guestId');
  return { userId, guestId };
};
